module.exports = __webpack_public_path__ + "img/VetoSans-Bold.3bb9e3b2.svg";